export enum AgreementState {
    active = 2,
    disable = 3
}
